// Lawyer chunks

const Cases = () =>
  import(
    /* webpackChunkName: "lawyer" */
    "@/views/Lawyer/Cases/index"
  );

const Case = () =>
  import(
    /* webpackChunkName: "lawyer" */
    "@/views/Lawyer/Case/index"
  );

const lawyerRoutes = [
  {
    path: "/lawyer/cases",
    name: "lawyer-cases",
    component: Cases,
    meta: {
      auth: "lawyer",
      title: "Layer cases",
    },
  },

  {
    path: "/lawyer/cases/:case_id",
    name: "lawyer-case",
    component: Case,
    meta: {
      auth: "lawyer",
      title: "Cases",
    },
  },
];

export default lawyerRoutes;
